import styled from 'styled-components';

import { TextColorSmallIcon } from 'containers/Tiptap/components/tiptap-icons/text-color-small-icon';

export const StyledTextColourIcon = styled(TextColorSmallIcon)<{ $colour?: string }>`
  &&& {
    ${({ $colour }) => ($colour ? `color: ${$colour};` : '')}
  }
`;

export const StyledTextColourRing = styled.span`
  && {
    width: 20px;
    height: 20px;
    margin: 0;
  }

  .tiptap-button-icon {
    width: 14px;
    height: 14px;
  }
`;

export const StyledDefaultTextSwatch = styled.span`
  &&::after {
    border: 1px solid var(--tiptap-ouline-fallback-color);
    filter: brightness(95%);
    opacity: 1;
  }
`;

export const StyledSwatchRow = styled.div`
  && {
    gap: 0;
  }

  .tiptap-button {
    min-width: 0;
    padding: 16px ${({ theme }) => theme.spacing(0.5)};
  }

  .tiptap-button-color-text {
    width: 20px;
    height: 20px;
    margin: 0;
  }

  .tiptap-button-color-text .tiptap-button-icon {
    width: 14px;
    height: 14px;
  }
`;
